import { Component } from 'react';
import PropTypes from 'prop-types';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { HybridTiers } from 'app/common/react/components/growth/unauth/open/hybrid/hybridConstants';

const IMAGES = 'images';
const UNKNOWN = 'unknown';
const WEB = 'web';

export const loggingSettings = (page) => {
  switch (page) {
    case 'pin':
    case 'pinFeedBack':
      return { viewType: PCONST.thrift.ViewType.PIN };
    case 'board':
      return {
        viewType: PCONST.thrift.ViewType.BOARD,
        viewParameter: PCONST.thrift.ViewParameterType.BOARD_OTHERS,
      };
    case 'article':
      return { viewType: PCONST.thrift.ViewType.ARTICLE };
    case 'explore':
      return { viewType: PCONST.thrift.ViewType.DISCOVER };
    case 'home':
      return {
        viewType: PCONST.thrift.ViewType.FEED,
        viewParameter: PCONST.thrift.ViewParameterType.FEED_HOME,
      };
    case 'login':
      return { viewType: PCONST.thrift.ViewType.LOGIN };
    case 'businessLogin':
      return { viewType: PCONST.thrift.ViewType.BUSINESS_LOGIN };
    case 'klp':
      return {
        viewType: PCONST.thrift.ViewType.FEED,
        viewParameter: PCONST.thrift.ViewParameterType.FEED_INTEREST,
      };
    case 'topic':
      return {
        viewType: PCONST.thrift.ViewType.TOPIC_PAGE,
        viewParameter: PCONST.thrift.ViewParameterType.WEB_TOPIC_PAGE,
      };
    case 'search':
      return { viewType: PCONST.thrift.ViewType.SEARCH };
    case 'profile':
      return { viewType: PCONST.thrift.ViewType.USER };
    default:
      return undefined;
  }
};

const getHybridTierType = (hybridTier) => {
  if (hybridTier === HybridTiers.tier1) {
    return 'tier1';
  } else if (hybridTier === HybridTiers.tier2) {
    return 'tier2';
  } else if (hybridTier === HybridTiers.tier3) {
    return 'tier3';
  } else {
    return 'open';
  }
};
/**
 * Exposes page type context field
 */
export default class PageContext extends Component {
  getChildContext() {
    const { page, viewData, hybridTier } = this.props;
    return {
      logging: {
        ...loggingSettings(page),
        viewData,
      },
      pageType: page,
      hybridTier: getHybridTierType(hybridTier),
    };
  }

  componentDidMount() {
    const { page } = this.props;
    if (this.context.searchType === UNKNOWN) {
      trackRegisterAction('search_type.unknown.' + page);
    } else if (this.context.searchType === WEB) {
      trackRegisterAction('search_type.web.' + page);
    } else if (this.context.searchType === IMAGES) {
      trackRegisterAction('search_type.image.' + page);
      trackRegisterAction('image_search_query.' + page + '.' + this.context.searchQuery);
    }
  }

  render() {
    return this.props.children;
  }
}

PageContext.contextTypes = {
  searchQuery: PropTypes.string.isRequired,
  searchType: PropTypes.string.isRequired,
};

PageContext.childContextTypes = {
  logging: PropTypes.shape({
    viewParameter: PropTypes.number,
    viewType: PropTypes.number.isRequired,
    viewData: PropTypes.shape({
      interest: PropTypes.string,
    }),
  }),
  pageType: PropTypes.string.isRequired,
  hybridTier: PropTypes.string,
};

PageContext.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string.isRequired,
  viewData: PropTypes.shape({
    interest: PropTypes.string,
  }),
  hybridTier: PropTypes.string,
};
